import React from "react";
import { Dashboard } from "modules";

const DashboardPage = () => {
  return <Dashboard />;
};

export default DashboardPage;
